/**
 * Copyright (c) 2020
 *
 * @summary calls to dataReport/traffic API
 * @author Julien <julien.donnadieu@yooda.com>
 *
 * Created at     : 2020-11-17 10:21:56
 * Last modified  : 2020-11-17 15:31:17
 */

import axios from '@/api/axios.js'

export default {



    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readIncoming (projectId,filters=null) {
        return axios.get(`/report/data/projects/${projectId}/traffic/incoming`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readQualityConversion (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/traffic/quality/conversion`,filters)
    },
    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readQualitySale (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/traffic/quality/sale`,filters)
    },

    /**
     * @param projectId int
     * @returns Promise
     */
    readQualitySessionDuration (projectId) {
        return axios.get(`/report/data/projects/${projectId}/traffic/quality/session-duration`)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readQualityTotalConversion (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/traffic/quality/total-conversion`,filters)
    },
    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readQualityTotalSale (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/traffic/quality/total-sale`,filters)
    },
    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readQualityTotalTurnover (projectId,filters) {
        return axios.get(`/report/data/projects/${projectId}/traffic/quality/total-turnover`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readQualityTurnoverByVisitor (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/traffic/quality/turnover-by-visitor`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readQuality (projectId,filters=null) {
        return axios.get(`/report/data/projects/${projectId}/traffic/quality`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readSource (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/traffic/sources`,filters)
    },

};
